// features/template.fields.js

export const EMAIL_TEMPLATE_KEYS = [
  "ADMIN_APPROVAL_REQUIRED",
  "ADMIN_CONTACT_US",
  "ADMIN_FREE_ESTIMATION",
  "CLIENT_HELP_REQUEST",
  "LOGIN_VERIFICATION_OTP",
  "MANUAL_USER_CREATE",
  "NEW_CHAT_MESSAGE",
  "PASSWORD_UPDATED",
  "PROJECT_ASSIGNED",
  "PROJECT_ASSIGNED_TO_ADMIN",
  "PROJECT_COMPLETED",
  "PROJECT_DEADLINE_REMINDER",
  "PROJECT_ETA_UPDATE",
  "PROJECT_STATUS_UPDATE",
  "REGISTRATION_OTP",
  "RESET_PASSWORD_OTP",
  "USER_ACCOUNT_PENDING",
  "USER_CONTACT_US",
  "USER_FREE_ESTIMATION",
];

export const getTemplateFields = (isEditing = false) => [
  // ── Identity ──────────────────────────────────────────────────────────────
  {
    name:          "template_key",
    label:         "Template Key",
    type:          "select",
    required:      !isEditing,
    is_enums_data: true,
    enums:         EMAIL_TEMPLATE_KEYS,
    fullWidth:     true,
  },
  {
    name:     "template_name",
    label:    "Template Name",
    type:     "text",
    required: true,
  },
  {
    name:          "mailing_for",
    label:         "Mailing For",
    type:          "select",
    required:      false,
    is_enums_data: true,
    enums:         ["NOTIFICATIONS", "MARKETING"],
  },
  {
    name:          "email_type",
    label:         "Email Type",
    type:          "select",
    required:      false,
    is_enums_data: true,
    enums:         ["AUTH", "PROJECT_NOTIFICATION", "HELP", "CHAT_MESSAGE", "RESET_PASSWORD_OTP", "OTHER"],
  },

  // ── Content ───────────────────────────────────────────────────────────────
  {
    name:      "subject",
    label:     "Subject",
    type:      "text",
    required:  true,
    fullWidth: true,
  },
  {
    name:     "eyebrow",
    label:    "Eyebrow Text",
    type:     "text",
    required: false,
  },
  {
    name:     "heading",
    label:    "Heading",
    type:     "text",
    required: false,
  },
  {
    name:      "description",
    label:     "Description",
    type:      "textarea",
    required:  false,
    fullWidth: true,
    rows:      3,
  },
  {
    name:      "body_html",
    label:     "Body HTML",
    type:      "textarea",
    required:  true,
    fullWidth: true,
    rows:      12,
  },

  // ── Status ────────────────────────────────────────────────────────────────
  {
    name:         "is_activated",
    label:        "Active",
    type:         "boolean",
    defaultValue: true,
  },
];
